module.exports = __webpack_public_path__ + "fonts/Golos-Text_DemiBold.80fe81f.eot";